export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  groupClasses?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  children?: NavigationItem[];
  link?: string;
  description?: string;
  path?: string;
}

export const NavigationItems: NavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    icon: 'dashboard',
    children: [
      {
        id: 'default',
        title: 'Dashboard',
        type: 'item',
        classes: 'nav-item',
        url: '/dashboard/default',
        icon: 'analytics',
        breadcrumbs: false
      }
    ]
  },
   {
    id: 'school',
    title: 'Administración',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'messages',
        title: 'Mensajes',
        type: 'item',
        classes: 'nav-item',
        url: '/messages',
        icon: 'chat',
        breadcrumbs: false
      },
      {
        id: 'calendary',
        title: 'Calendario',
        type: 'item',
        classes: 'nav-item',
        url: '/calendar',
        icon: 'calendar_month',
        target: false,
        breadcrumbs: false
      }, {
        id: 'gruposlist',
        title: 'Grupos',
        type: 'item',
        classes: 'nav-item',
        url: '/listgroups',
        icon: 'local_library',
        target: false,
        breadcrumbs: false
      }, {
        id: 'aperturas',
        title: 'Aperturas',
        type: 'item',
        classes: 'nav-item',
        url: '/aperturas',
        icon: 'dashboard_customize',
        target: false,
        breadcrumbs: false
      },
          {
        id: 'listalumno',
        title: 'Alumnos',
        type: 'item',
        classes: 'nav-item',
        url: '/alumnos',
        icon: 'school',
        target: false,
        breadcrumbs: false
      },
      {
        id: 'newalumno',
        title: 'Inscripción',
        type: 'item',
        classes: 'nav-item',
        url: '/inscripcion',
        icon: 'group_add',
        target: false,
        breadcrumbs: false
      },
      {
        id: 'teacher',
        title: 'Teachers',
        type: 'item',
        classes: 'nav-item',
        url: '/docentes',
        icon: 'book_ribbon',
        target: false,
        breadcrumbs: false
      },
      {
        id: 'penditepago',
        title: 'Pagos',
        type: 'item',
        classes: 'nav-item',
        url: '/pagos',
        icon: 'monetization_on',
        target: false,
        breadcrumbs: false
      },
    ]
  },
  // {
  //   id: 'authentication',
  //   title: 'Authentication',
  //   type: 'group',
  //   icon: 'icon-navigation',
  //   children: [
  //     {
  //       id: 'login',
  //       title: 'Login',
  //       type: 'item',
  //       classes: 'nav-item',
  //       url: '/login',
  //       icon: 'login',
  //       target: true,
  //       breadcrumbs: false
  //     },
  //     {
  //       id: 'register',
  //       title: 'Register',
  //       type: 'item',
  //       classes: 'nav-item',
  //       url: '/register',
  //       icon: 'profile',
  //       target: true,
  //       breadcrumbs: false
  //     }
  //   ]
  // },
  // {
  //   id: 'utilities',
  //   title: 'UI Components',
  //   type: 'group',
  //   icon: 'icon-navigation',
  //   children: [
  //     {
  //       id: 'typography',
  //       title: 'Typography',
  //       type: 'item',
  //       classes: 'nav-item',
  //       url: '/typography',
  //       icon: 'font-size'
  //     },
  //     {
  //       id: 'color',
  //       title: 'Colors',
  //       type: 'item',
  //       classes: 'nav-item',
  //       url: '/color',
  //       icon: 'bg-colors'
  //     },
  //     {
  //       id: 'ant-icons',
  //       title: 'Ant Icons',
  //       type: 'item',
  //       classes: 'nav-item',
  //       url: 'https://ant.design/components/icon',
  //       icon: 'ant-design',
  //       target: true,
  //       external: true
  //     }
  //   ]
  // },
  {
    id: 'settings',
    title: 'Configuración',
    type: 'group',
    icon: 'icon-navigation',
    children: [
            {
        id: 'usuarios',
        title: 'Usuarios',
        type: 'item',
        classes: 'nav-item',
        url: '/usuarios',
        icon: 'groups',
        target: false,
        breadcrumbs: false
      },
      {
        id: 'catalogos',
        title: 'Catálogos',
        type: 'item',
        url: '/catalogos',
        classes: 'nav-item',
        icon: 'settings_b_roll'
      }
    ]
  },
  // {
  //   id: 'other',
  //   title: 'Other',
  //   type: 'group',
  //   icon: 'icon-navigation',
  //   children: [
  //     {
  //       id: 'sample-page',
  //       title: 'Sample Page',
  //       type: 'item',
  //       url: '/sample-page',
  //       classes: 'nav-item',
  //       icon: 'chrome'
  //     },
  //     {
  //       id: 'document',
  //       title: 'Document',
  //       type: 'item',
  //       classes: 'nav-item',
  //       url: 'https://codedthemes.gitbook.io/mantis-angular/',
  //       icon: 'question',
  //       target: true,
  //       external: true
  //     }
  //   ]
  // }
];
